<script setup lang="ts">
import type { CommentSummaryDto } from '@/services/types/api.types';
import { useClipboard } from '@vueuse/core';
import { ref } from 'vue';

const { copy } = useClipboard({ legacy: true });

const props = defineProps<{
  entry: CommentSummaryDto;
}>();

const mode = ref<'view' | 'edit'>('view');

if (props.entry.id === -1) {
  mode.value = 'edit';
}

const emit = defineEmits<{
  (e: 'save', id: number, text: string): void;
  (e: 'delete', id: number): void;
  (e: 'cancelEdit', id: number): void;
}>();

const text = ref(props.entry.text);

const setEditMode = (isEdit: boolean) => {
  mode.value = isEdit ? 'edit' : 'view';
  text.value = props.entry.text;
};

const onSave = () => {
  emit('save', props.entry.id, text.value);
  setEditMode(false);
};

const onCancelEdit = () => {
  emit('cancelEdit', props.entry.id);
  setEditMode(false);
};

const onDelete = () => {
  emit('delete', props.entry.id);
};
</script>

<template>
  <div class="comment-summary-entry q-my-sm">
    <div class="row items-center" v-if="mode === 'edit'">
      <div class="col">
        <q-input v-model="text" outlined type="textarea" />
      </div>
      <div class="col-md-auto q-gutter-sm q-ml-md">
        <q-btn dense rounded size="sm" color="positive" icon="done" @click.stop="onSave" />
        <q-btn dense rounded size="sm" color="negative" icon="close" @click.stop="onCancelEdit" />
      </div>
    </div>
    <div class="comment-summary-entry__view_container" v-if="mode === 'view'">
      <!--<q-chip :label="entry.text" />-->
      <p class="comment-summary-entry__entry_text">{{ entry.text }}</p>
      <div class="q-gutter-sm q-ml-sm">
        <q-btn dense unelevated size="sm" icon="content_copy" @click="copy(entry.text)" />
        <q-btn dense unelevated size="sm" icon="edit" @click.stop="setEditMode(true)" />
        <q-btn dense unelevated size="sm" icon="delete" @click.stop="onDelete" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.comment-summary-entry {
  .comment-summary-entry__entry_text {
    margin: 0;
    flex-grow: 1;
  }

  .comment-summary-entry__view_container {
    display: flex;
    align-items: center;
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 8px;
    background-color: #f0f0f0;
  }
}
</style>
